import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import styled, { css } from 'styled-components'
import { getTheme } from '../../global/utils'
import Auth from "../../services/Auth";

const NavItem = styled.li`
  display: block;
  list-style: none;
  color: ${getTheme('textColor', 'white')};
  font-weight: bold;

  && a {
    color: ${getTheme('textColor', 'white')};
    text-decoration: none;
    background: transparent;
    display: flex;
    align-items: center;
    min-height: ${getTheme('height', 'm')};
    padding: ${getTheme('padding', 'verticalS')}
      ${getTheme('padding', 'horizontalNav')};

    &:hover {
      background: ${getTheme('black', '_200')};
      color: inherit;
    }

    &:active {
      background: ${getTheme('black', '_300')};
      color: inherit;
    }

    &.active {
      background: ${getTheme('bg', 'active')};
      color: ${getTheme('bg', 'dark1')};

      &:hover {
        background: ${getTheme('bg', 'activeHover')};
      }
      &:active {
        background: ${getTheme('bg', 'activeDark')};
      }

      .navitem__icon {
        color: ${getTheme('bg', 'dark1')};
      }
    }
  }

  .navitem__icon {
    margin-right: ${getTheme('spacer', 's')};
    color: ${getTheme('textColor', 'primaryLight')};
  }

  ${(props) =>
    props.disabled &&
    css`
      opacity: 0.25;
      pointer-events: none;
    `};
`
const auth = new Auth();

class SideNavItem extends Component {
    render() {
        let showItem = true;
        if (this.props.rol) {
            showItem = (auth.getRol() === this.props.rol);
        }
        if (!showItem) {
            return ('');
        }

        let linkWrapper;
        if (this.props.external) {
            linkWrapper =
                <a href={this.props.url} target="_blank">
                    <div className="navitem__icon">{this.props.icon}</div>
                    {this.props.text}
                </a>
        } else{
            linkWrapper =
                <NavLink to={this.props.url}>
                    <div className="navitem__icon">{this.props.icon}</div>
                    {this.props.text}
                </NavLink>
        }
        return (
            <NavItem disabled={this.props.disabled}>
                {linkWrapper}
            </NavItem>
        )
    }
}

export default SideNavItem



// WEBPACK FOOTER //
// ./src/components/navs/SideNavItem.js